import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, login as loginApi, logoutApi } from "../lib/api";

const AuthContext = createContext(null);
const STAGE_KEY = "currentStage";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const [currentStage, setCurrentStageState] = useState(() => {
    try { return localStorage.getItem(STAGE_KEY) || "all"; } catch { return "all"; }
  });

  const setCurrentStage = (s) => {
    setCurrentStageState(s);
    try { localStorage.setItem(STAGE_KEY, s); } catch { /* ignore */ }
  };

  const loadMe = useCallback(async () => {
    try {
      const data = await fetchMe();
      setUser(data);
      // If user has restricted stages and no/invalid currentStage, default to first
      if (data?.assigned_stages?.length) {
        const cs = localStorage.getItem(STAGE_KEY) || "all";
        if (cs !== "all" && !data.assigned_stages.includes(cs)) {
          setCurrentStage(data.assigned_stages[0]);
        }
      }
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (username, password) => {
    const data = await loginApi(username, password);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await logoutApi(); } catch { /* ignore */ }
    setUser(null);
    setCurrentStage("all");
  };

  return (
    <AuthContext.Provider value={{ user, loading: user === undefined, login, logout, loadMe, currentStage, setCurrentStage }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
